import { QuoteApiModel } from '~/lib/api/smartsend/types';
import { onlyUnique } from '../../../../lib/helpers/ArrayHelper';
import { RoyalMailProvider } from '~/lib/consts/providers';

export const ServiceTagTypeOptions = [
  'Signed For',
  'Special Delivery',
  'Standard Letter',
  'Large Letter',
  'Parcel'
  // These will be added in when all the OBA services get rolled out.
  // 'HM Forces',
  // 'Proof of Age',
  // 'Proof of Identity',
  // 'LetterBox',
] as const;
export type ServiceTagType = (typeof ServiceTagTypeOptions)[number];

export const ServiceSpeedTypeOptions = ['Fast', 'Medium', 'Slow'] as const;

export type ServiceSpeedType = (typeof ServiceSpeedTypeOptions)[number];

export const PopulateQuoteTags = (quote: QuoteApiModel) => {
  const newTags: ServiceTagType[] = [];

  switch (quote.Service?.Provider) {
    // Sanitise the data from Intersoft.
    // Will look to do this at source when we confirm reason for bad data.
    case RoyalMailProvider:
      quote.Service.Name = quote.Service.Name.replace('(LL)', '')
        .replace('(P)', '')
        .replace('(L)', '')
        .replace('(PP)', '')
        .replace('Guaranteed By', 'Guaranteed\nBy')
        .replace('Singed', 'Signed')
        .replace('Soted', 'Sorted');
  }

  quote.Service.Tags = [...quote.Service.Tags, ...newTags].filter(onlyUnique);

  return quote;
};
